module.exports = __webpack_public_path__ + "img/espaço-6.a94712bb.jpeg";